import angular from 'angular';
import mergeFieldsSelection from './mergeFieldsSelection';

export default angular
  .module('components.mergeFields', [])
  .component('mergeFieldsSelection', mergeFieldsSelection).name;
